import React, { useEffect, useState,useCallback } from "react";
import wrap from "word-wrap";
import {
  ImportIcon,
  ResetIcon,
  DeleteIcon,
  DisabledIcon,
  KeyIcon
} from '@shopify/polaris-icons';
import {
    Page,
    Card,
    Layout,
    IndexTable,
    Modal,
    LegacyCard,
    ProgressBar,
    IndexFiltersCancelAction,
    Button,
    EmptyState,
    Text,
    SkeletonBodyText,
    RangeSlider,
    ActionList,
    Pagination,
    ChoiceList,
    Select,
    IndexFilters,
    Icon,
    Popover,
    Banner,
    useSetIndexFiltersMode,
    Image,
    Badge,
    InlineStack,
     TextContainer,
    TextField,
    Link,
    useIndexResourceState,
    Tooltip
  } from "@shopify/polaris";
import  {IndexFiltersProps, TabProps} from '@shopify/polaris';
import { SearchIcon ,InboundIcon} from '@shopify/polaris-icons';
import "../App.css";
import defaultInage from '../assets/image.jpg'
import useIsMobile from './useIsMobile';
import { TbArrowsSort } from "react-icons/tb";
import { useStoreData } from './hooks/useStoreData';
import { RiDeleteBin6Line } from "react-icons/ri";
import { BiImport } from "react-icons/bi";
import { CgImport } from "react-icons/cg";
import { MdBlockFlipped } from "react-icons/md";
import { CgUnblock } from "react-icons/cg";
import SearchBar from "./common/SearchBar";
import ProgressAnimation from "./common/ProgressAnimation";
import { toast } from "react-toastify";
import Axios from "./common/Axios";
import { useNavigate } from "react-router-dom";
import LoadingBar from "./common/Loading";

function Products() {


  const savedData = localStorage.getItem("storeData");
  const localData = savedData ? JSON.parse(savedData) : null;
  const [showInfo,setShowInfo] = useState(true);
  // Redirect to login if no data found
    const [isLoading, setIsLoading] = useState(false);

  const data = localData;
  const siteId = data?.user?.eb_key[0]?.siteid ?? 0;
  const shopurl = data?.user?.shopurl || "";
  let requestss = data.user?.eb_requests_pending ?? 0;
  const [eb_pending_request , setEbPendingRequest] = useState(requestss);
  //console.log("data.user.eb_requests_pending",data.user.eb_requests_pending);
  
  // const ebPend
  const storeName = shopurl.replace(".myshopify.com", "");
  const [whichPage,setwhichPage] = useState("products");
  const [searchValue, setSearchValue] = useState("");
  const [productNotExists, setProductNotExists] = useState(false);
  const [isBar, setBar] = useState(false);
const [parPage,setParPage] = useState(20);
const [upgradeModalActive, setUpgradeModalActive] = useState(false);
const [allProductCount,setAllProductCount] = useState([]);
const toggleUpgradeModal = () => setUpgradeModalActive((prev) => !prev);
  const [productData, setproductData] = useState(false);
const [last_page,setLastPage] = useState(1);

  const [selectImportIds,setSelectedImport] = useState([]);
  const [selectReImportIds,setSelectedReImport] = useState([]);
  const [selectDeleteProductIds,setSelectedDeleteProduct] = useState([]);

  const localProductCountData =  localStorage.getItem("productCount");
  const productCount = localProductCountData ? JSON.parse(localProductCountData) : null;

  const [sortValue, setSortValue] = useState('newestProduct');
  const [statusValue, setStatusValue] = useState('readytoimport');
  const [showAction,setShowAction] = useState(false);
  const {mode, setMode} = useSetIndexFiltersMode();
  const [totalpage,setTotalPage] = useState(0);
  const [firstProductNo,setFirstProdcutNo] = useState(0);
  const [LastProductNo,setLastProductNo] = useState(0);
  const [current_page,setCurrentPage] = useState(0);
  const [query,setQuery] = useState('Product desc')
  const [perPageValue,setPerPageValue] = useState("20");
  const [active, setActive] = useState(false);
  const [page,setPage] = useState(1);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [importedProductCount,setImportedProductCount] = useState();
  const [reImportedProductCount,setReImportedProductCount] = useState(0);




const handleOpen = (variants) => {
  setSelectedVariants(variants);
  setActive(true);
};
const getBadgeTone = (status) => {

  switch (status.toLowerCase()) {
    case "ready to import":
      return "info";
    case "import in progress":
    case "reimport in progress":
      return "warning";
    case "imported":
      return "success";
    case "already exist":
      return "attention";
    case "error":
      return "critical";
    default:
      return "attention";
  }
};
   const domainSite = {
        0: 'https://www.ebay.com',
        2: 'https://www.ebay.ca',
        3: 'https://www.ebay.co.uk',
        15: 'https://www.ebay.com.au',
        16: 'https://www.ebay.at',
        23: 'https://www.befr.ebay.be',
        71: 'https://www.ebay.fr',
        77: 'https://www.ebay.de',
        100: 'https://www.ebay.com',
        101: 'https://www.ebay.it',
        123: 'https://www.benl.ebay.be',
        146: 'https://www.ebay.nl',
        186: 'https://www.ebay.es',
        193: 'https://www.ebay.ch',
        201: 'https://www.ebay.com.hk',
        205: 'https://www.ebay.ie',
        207: 'https://www.ebay.com.my',
        210: 'https://www.cafr.ebay.ca',
        211: 'https://www.ebay.ph',
        212: 'https://www.ebay.pl',
        216: 'https://www.ebay.com.sg'
      };

const domain = domainSite[siteId];

const statusFilter = [
  { label: 'Ready To Import', value: 'readytoimport' },
  { label: 'Import In Progress', value: 'importinprogress' },
  { label: 'Imported', value: 'imported' },
  { label: 'Error', value: 'error' },
  { label: 'Already Exist', value: 'AlreadyExist' }
];
const [selected, setSelected] = useState('today');

const handleSelectChange = useCallback(
  // (value: string) => setSelected(value),
  // [],
);

const options = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 days', value: 'lastWeek' },
];
const [Actionselected, AsetSelected] = useState('ISP');


const Actionoptions = [
  { label: 'Import Selected Products', value: 'ISP', prefix: <BiImport style={{ fontSize: "1.2rem" }} /> },
  { label: 'Import All Unblocked Products', value: 'IAUP', prefix: <CgImport style={{ fontSize: "1.2rem" }} /> },
  { label: 'Reimport Selected Products', value: 'RSP', prefix: <BiImport style={{ fontSize: "1.2rem" }} /> },
  { label: 'Delete Products', value: 'DP', prefix: <RiDeleteBin6Line style={{ fontSize: "1.2rem" }} />, },
  { label: 'Block Selected Products', value: 'BSP', prefix: <MdBlockFlipped style={{ fontSize: "1.2rem" }} /> },
  { label: 'Unblock Selected Products', value: 'USP', prefix: <CgUnblock style={{ fontSize: "1.2rem" }} /> },
];

const handleClose = () => setActive(false);
const resourceName = {
  singular: 'product',
  plural: 'products',
};
const isMobile = useIsMobile();

    const [products, setProducts] = useState([]);
    const {selectedResources, allResourcesSelected, handleSelectionChange} = useIndexResourceState(products);
    
    useEffect(() => {
        setIsLoading(true);

        const fetchproduct = async () => {
          try {
            
            const response = await Axios.get('/product')
            if (response.data.total === 0) {
              setProductNotExists(true);
            }else{
              setProductNotExists(false);
            }
            setproductData(true);
            setIsLoading(false);

           const result = response.data;
           setTotalPage(response.data.total);
           setFirstProdcutNo(response.data.from);
           setLastProductNo(response.data.to);
           setCurrentPage(response.data.current_page);
           setPerPageValue(response.data.per_page);
           setLastPage(response.data.last_page);
            if (response && response.data) {

              const formattedProducts = result.data.map((product) => {
            
              
                return {
                  id: product.product_id,
                  title:  wrap(product.title, { width: 40 }),
                  ebayitemid: product.ebayitemid,
                  shopifyProductId: product.shopifyproductid ? product.shopifyproductid : 0,
                  status: product.status,
                  variants: product.variants ? product.variants.length : 0,
                  image :product?.variants?.[0]?.main_image?.imgurl || "",
                  variations: product.variants
                    ? product.variants.map((variant) => ({
                        title: variant.option1val || "Default Option",
                        ebayitemid: variant.ebayitemid,
                        quantity: variant.quantity,
                        price: variant.price,
                        option1: variant.option1val || "-",
                        option2: variant.option2val || "-",
                        option3: variant.option3val || "-",
                      }))
                    : [],
                };
              });
              
              setProducts(formattedProducts);
              setProducts(formattedProducts);
            }
          } catch (error) {
            console.error("Error fetching products:", error);
          }
        }; 
    
        fetchproduct();
      }, []);

     
      
      useEffect(() => {
        if (Array.isArray(selectedResources) && selectedResources.length > 0) {
        
          if (data.user.plan === 0) {
            if (selectedResources.length > 5) {
              //console.log(selectedResources);
            }
          }
          const filteredProductIds = products
            .filter(product =>
              selectedResources.includes(product.id) && product.status === 'Ready to Import'
            )
            .map(product => product.id);  // Get only the IDs of the filtered products
            if (data.user.plan  === 0) {
              if (data.user.skuconsumed >= data.user.skulimit) {
                setUpgradeModalActive(true);
              }else{

                const importIds = filteredProductIds.slice(0,data.user.skulimit - data.user.skuconsumed);
                setSelectedImport(importIds);
          setImportedProductCount(importIds.length);

              }
              
            }else{

              setSelectedImport(filteredProductIds);
          setImportedProductCount(filteredProductIds.length);

            }

          const filteredReProductIds = products
          .filter(product =>
            selectedResources.includes(product.id) && product.status === 'Imported'
          )
          .map(product => product.id);  // Get only the IDs of the filtered products
          setSelectedReImport(filteredReProductIds);
          setSelectedDeleteProduct(filteredReProductIds);
        setReImportedProductCount(filteredReProductIds.length);
        } else {
          setImportedProductCount(0);
        }
      }, [selectedResources, products]);


  
      
   const fetchproduct = async (query = "", page = 1, perPage) => {
  setIsLoading(true);
  setproductData(false);
  setQuery(query);

  const params = {
    page,
    per_page: perPage,
    ...(query && { query }),
  };

  try {
    const { data } = await Axios.get("/product", { params });

    const {
      total,
      from,
      to,
      current_page,
      per_page,
      last_page,
      data: products,
    } = data;

    setProductNotExists(total === 0);

    // Group all pagination-related state updates
    setTotalPage(total);
    setFirstProdcutNo(from);
    setLastProductNo(to);
    setCurrentPage(current_page);
    setPerPageValue(per_page);
    setLastPage(last_page);

    if (!products || products.length === 0) {
      console.warn("No products found.");
      setProducts([]);
    } else {
      const formattedProducts = products.map((product) => ({
        id: product.product_id,
        title: wrap(product.title, { width: 50 }),
        ebayitemid: product.ebayitemid,
        status: product.status,
        shopifyProductId: product.shopifyproductid || 0,
        variants: product.variants?.length || 0,
        image: product.variants?.[0]?.main_image?.imgurl || "",
        variations: Array.isArray(product.variants)
          ? product.variants.map((variant) => ({
              title: variant.option1val || "Default Option",
              ebayitemid: variant.ebayitemid,
              quantity: variant.quantity,
              price: variant.price,
              option1: variant.option1val || "-",
              option2: variant.option2val || "-",
              option3: variant.option3val || "-",
            }))
          : [],
      }));

      setProducts(formattedProducts);
    }

    setproductData(true);
  } catch (error) {
    console.error("Error fetching products:", error);
  } finally {
    setIsLoading(false);
  }
};

      const rePublishRequest = async (product_id)=>{
        try {
          setBar(true);
          setProducts((prevProducts) =>
            prevProducts.map((product) => {
              const ids = Array.isArray(product_id) ? product_id : [product_id];
              return ids.includes(product.id)
                ? { ...product, status: 'reimport in progress' }
                : product;
            })
          );
          
            const response = await Axios.post(`/product/reimport/${product_id}`);
            toast.success('Your product are Re- Import after sometime');

        
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      }
      const deleteRequest = async(id)=>{
        try {
           setProducts((prevProducts) =>
            prevProducts.map((product) => {
              const ids = Array.isArray(id) ? id : [id];
              return ids.includes(product.id)
                ? { ...product, status: 'Ready to Import' ,shopifyProductId:''}
                : product;
            })
          );
            const response = await Axios.post(`/product/remove/${id}`);
            toast.success('The products have been successfully deleted from your Shopify store.');
        } catch (error) {
          console.error(error);
          
        }
      }
      const deleteProductRequest = async(product_id)=>{
        try{
          
          
          if (!product_id || (Array.isArray(product_id) && product_id.length === 0)) {
            toast.error('The Delete Function only works when product is imported.');
            return;
          }
          setProducts((prevProducts) =>
            prevProducts.map((product) => {
              const ids = Array.isArray(product_id) ? product_id : [product_id];
              return ids.includes(product.id)
                ? { ...product, status: 'Ready to Import' }
                : product;
            })
          );
          const response = await Axios.post(`/product/remove/${product_id}`);
          
          toast.success('Your Imported Product Are Delete On Shopify');
        }catch(error){

          
          if (error.response.status === 406) {
            toast.error(error.response.data.error.msg[0]);
          }
        }
      }
    
      const publishRequest = async (product_id) => {
        let toastId;
        try {

          setBar(true);
          //console.log('product_id',product_id);
          const ids = Array.isArray(product_id) ? product_id : [product_id];
          //console.log('product_id',product_id);

          const savedData1 = localStorage.getItem("storeData");
          const localData1 = savedData ? JSON.parse(savedData) : null;          // FREE PLAN
          if (localData1.user.plan === 0) {

            const remainingSku = localData1.user.skulimit - localData1.user.skuconsumed;
            if (remainingSku <= 0) {
              setUpgradeModalActive(true);
              return;
            }
           toastId = toast.loading("Import in progress...");
       
            const allowedIds = ids.slice(0, remainingSku);
            const newids = Array.isArray(allowedIds) ? allowedIds : [allowedIds];
            //console.log(newids);
            setProducts((prevProducts) =>
              prevProducts.map((product) =>
                newids.includes(product.id)
                  ? { ...product, status: 'Import in progress'}
                  : product
              )
            );
           let response = await fetch('https://cp2.infoshoreapps.com/cronjobs/processimporttrial.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: new URLSearchParams({
                sbkey: data.user.id,
                productIdall: newids.join(','), 
              }),
            });
            if (!response.ok) {
              toast.dismiss(toastId);
              //console.log(`Request failed with status: ${response.status}`);
              const errorText = await response.text(); 
              //console.log(errorText);
              return;
            }else{
              //console.log("in else inside");
              //console.log('response',response);
              
          const result = await response.json(); 
          //console.log('API Response:', result);
          toast.update(toastId, {
            render: "The import process has been completed successfully.",
            type: "success",
            isLoading: false,
            autoClose: 4000,
          });
          const { skuconsumed } = result;
          localStorage.setItem('showArrow',1);
               localData.user.skuconsumed = skuconsumed;
               //console.log(localData.user);
              let userData = localData;
              userData.user.skuconsumed = skuconsumed;
              //console.log('userData',userData);
              
              localStorage.setItem("storeData", JSON.stringify(userData));
              setProducts((prevProducts) =>
                prevProducts.map((product) =>
                  newids.includes(product.id)
                    ? { ...product, status: 'Imported' }
                    : product
                )
              );
            }
            toast.dismiss(toastId);
            fetchproduct(query,current_page, perPageValue);
          } else {
            // PAID PLAN
            const response = await Axios.post(`/product/push/${product_id}`);
            toast.success(response.data.message);
            fetchproduct(query,current_page, perPageValue);
            const ids = Array.isArray(product_id) ? product_id : [product_id];
            localData.user.skuconsumed = ids.length;
            localStorage.setItem("storeData", JSON.stringify(localData));
            setProducts((prevProducts) =>
              prevProducts.map((product) =>
                ids.includes(product.id)
                  ? { ...product, status: 'Import in progress' }
                  : product
              )
            );
          }
        } catch (error) {
            toast.dismiss(toastId);
            //console.log(error);
            fetchproduct(query);
          if (error.response?.data?.error?.msg[0]) {
            toast.error(error.response?.data?.error?.msg[0])
               setUpgradeModalActive(true);
               return;
          }
        }
      };
      
      useEffect(() => {
          if (selectedResources.length > 0) {
              setShowAction(true);
          } else {
              setShowAction(false);
          }
      }, [selectedResources]);

      const FetchEbProducts = async ()=>{
        try {
          const response = await Axios.put(`/fetchEbayProduct/request`);
         
           toast.success("Your eBay products are being fetched. This may take a few moments.");
         
        } catch (error) {
          if (error.response.status === 406) {
            toast.error(error.response.data.error.msg[0]);
          }
          
        }
      }

      const handleSortChange = (value) => {
        //console.log(value);
        setSortValue(value); 
        fetchproduct(value);
      
      };
      const handlePerPage = (event) => {
        setPerPageValue(event.target.value);
        
        fetchproduct(query,page,event.target.value)
        //console.log(event.target.value); 

      };
  
      const handleAllSelections = (value)=>{
        //console.log(value);
        
      }
      const handleStatusChange = (value)=>{
        setStatusValue(value)
        fetchproduct(value);
      }
      const handleSearchChange = async (value) => {
        setSearchValue(value);
        
        if (value.length > 1) {
          fetchproduct(value);
        } else {
          setProducts([]); 
        }
      };
      const handleSelectItem = (id) => {
        //console.log("Selected ID:", id);
        // Perform any action you need with this ID
    };
    const handleSelectAll = useCallback((value) => {
      //console.log("all ",value);
    
    }, []);
      const rowMarkup = products.map(
    
  ({ id, image, title, ebayitemid, status, variants, variations ,shopifyProductId}, index) => (

<IndexTable.Row
id={id}
key={id}
position={index}
selected={selectedResources.includes(id)}
onClick={() => handleSelectItem(id)}
>
<IndexTable.Cell>
  <img
    src={image || defaultInage}
    alt={ebayitemid}
    width="50"
     className="iamgeProduct" 
    height="50"
  />
</IndexTable.Cell>

<IndexTable.Cell>

  <Text as="p" fontWeight="medium">
    {title.split("\n").map((line, idx) => (
      <span key={idx}  >
        {line}
        <br />
      </span>
    ))}
  </Text>

  <Text  as="strong">
    eBay Item ID:{" "}
    <a
      href={`${domain}/itm/${ebayitemid}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="ebay-link"
    >
      {ebayitemid}
    </a>
  </Text>
</IndexTable.Cell>

<IndexTable.Cell>
  {status === "Import in progress" ? (
    // Import in progress
    <Badge tone={getBadgeTone(status)}>{status}</Badge>

    // <ProgressAnimation />
  ) : (
    <Badge tone={getBadgeTone(status)}>{status}</Badge>
  )}
</IndexTable.Cell>

<IndexTable.Cell>
  <div className=''>

                    <Link  monochrome removeUnderline onClick={() => handleOpen(variations)}>{variants} variants</Link>
  </div>
  
</IndexTable.Cell>
<IndexTable.Cell>
    <a
          href={`${domain}/itm/${ebayitemid}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
    <img src={`https://cp2.infoshoreapps.com/cp/assets/ebay.png`} width="50" height="25" alt="Shopify Product" />
    </a>
    { shopifyProductId !=0 && (
         <a href={`https://admin.shopify.com/store/${storeName}/products/${shopifyProductId}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="shopify-link"
          >
            <img
              src={`https://cp2.infoshoreapps.com/cp/assets/shopify.png`}
              width="40"
              height="40" 
              alt="Shopify Product"
            />
          </a>
    )}
</IndexTable.Cell>
<IndexTable.Cell>
  {status === "Imported"  ? (
     data.user.plan > 0 && (
      <>
      <div style={{ display: 'flex', gap: '8px' }}>
        <Button onClick={() => rePublishRequest(id)}>ReImport</Button>
        <Tooltip content="Delete From shopify">

           <Button onClick={() => deleteRequest(id)} tone="critical">Delete</Button>
        </Tooltip>
      </div>
    </>
    )
  ) : (
    <Tooltip content='Click here to import eBay listings into your Shopify store.' >
         <Button
         variant="primary"
      onClick={() => publishRequest(id)}
      disabled={status === "Import in progress" || status === "reimport in progress"}
      >
      Import On Shopify
    </Button>
    </Tooltip>
  )}
</IndexTable.Cell>
</IndexTable.Row>

        )
      );
      const [popoverActiveSort, setPopoverActiveSort] = useState(false);
      const [popoverActiveStatus, setPopoverActiveStatus] = useState(false);
      const [popoverActiveAction, setPopoverActiveAction] = useState(false);



      const togglePopoverActiveSort = useCallback(
        () => setPopoverActiveSort((active) => !active),
        []
      );
      const togglePopoverActiveStatus = useCallback(
        () => setPopoverActiveStatus((active) => !active),
        []
      );
      const togglePopoverActiveAction = useCallback(
        () => setPopoverActiveAction((active) => !active),
        []
      );
    
      const activatorSort = (
        <Button onClick={togglePopoverActiveSort} disclosure>
            <TbArrowsSort size={19} onSortChange={handleSortChange} />
        </Button>
      );
      const activatorAction = (
        <Button onClick={togglePopoverActiveAction} disclosure>
            Action
        </Button>
      );
      const activatorStatus = (
        <Button onClick={togglePopoverActiveStatus} disclosure>
            Status
        </Button>
      );
  
      const handleSelectedRow = (id) => {
        //console.log(`Processing row with ID: ${id}`);
        // Add your custom logic here (e.g., API call, state update, etc.)
        // Example: Fetch details, update state, or trigger an action
        // setProducts((prevProducts) =>
        //   prevProducts.map((product) =>
        //     product.id === id ? { ...product, isSelected: true } : product
        //   )
        // );
      };
 
      const promotedBulkActions = [
        importedProductCount > 0 && {
          content: `Import ${importedProductCount} Selected Products`,
          onAction: () => {
            if (importedProductCount > 0) {
              publishRequest(selectImportIds);
            }
          },
        },
        (reImportedProductCount > 0 && data.user.plan > 0) && {
          content:`ReImport ${reImportedProductCount} Selected Products`,
          onAction: () => rePublishRequest(selectReImportIds), 
        },
        data.user.plan > 0 && {
          title: 'Action',
          actions: [
            {
              icon: ImportIcon,
              content: 'Import Selected Product ',
              onAction: () =>publishRequest(selectImportIds),
            },
            reImportedProductCount > 0 &&  {
              icon: ResetIcon,
              content: 'Reimport Selected Products',
              onAction: () => rePublishRequest(selectReImportIds), 
            },
            {
              icon: DeleteIcon,
              destructive: true,
              content: 'Delete Products',
              onAction: () => deleteProductRequest(selectDeleteProductIds),
            },
          ],
        },
      ].filter(Boolean); // This will remove any falsy value (like false) from the array

      let content;
      if (!productData) {
        content =    <Card>
                                       
                                       <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
        <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>             
              <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
            <LegacyCard subdued>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
          <LegacyCard.Section>
            <SkeletonBodyText lines={2} />
          </LegacyCard.Section>
        </LegacyCard>
                             
                                         </Card>;
      }else if (products.length === 0) {
      
          if (productCount.ebproduct == 0) {
             content =  <Card>        <EmptyState
                heading="Product Not Found On ebay"
                action={{content: 'Create ebay Product',url:`https://www.ebay.com/sl/prelist/home?sr=shListingsCTA`,target:"_blank" }}
        
                image="https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/empty-state-personalized-Bu4xlcHV0rQu.svg"
                fullWidth
              >
                 <Text variant="bodyLg" as="p">
                  You currently have no products available in your <strong>ebay store.</strong>  Please create a product to continue.
                 </Text>
               
              </EmptyState>
              </Card>
          }else{
            content =        <Card>
              <EmptyState
                heading="Product Not Found"
                image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                fullWidth
              >
              </EmptyState>
              </Card>
          }
        }else{
          content =                  <IndexTable
                    resourceName={resourceName}

                    itemCount={products.length}
                    onChange={handleAllSelections}
                    selectedItemsCount={allResourcesSelected ? 'All' : selectedResources.length}
                    onSelectionChange={handleSelectionChange}
                    // onSelectionChange={handleSelectAll}
                    promotedBulkActions={promotedBulkActions}
                headings={[
                  { title: <h2 style={{    fontSize: "1.1em",    fontWeight: "700"}}>Image</h2> },
                  { title: <h2 style={{    fontSize: "1.1em",    fontWeight: "700"}}>Title</h2> },
                  { title: <h2 style={{    fontSize: "1.1em",    fontWeight: "700"}}>Status</h2> },
                  { title: <h2 style={{    fontSize: "1.1em",    fontWeight: "700"}}>Variants</h2> },
                  { title: <h2 style={{    fontSize: "1.1em",    fontWeight: "700"}}>Open In</h2> },
                  { title: <h2 style={{    fontSize: "1.1em",    fontWeight: "700"}}>Actions</h2> },
                ]}
                  >
              { rowMarkup}
                                    </IndexTable>

        }
      
  return (
    <Page
      fullWidth
      title="Ebay Products"
      className="product-list"
      primaryAction={{
        content: 'Fetch eBay Products',
        onAction: FetchEbProducts,
        helpText: 'Fetch Products From Your Ebay Account.',
        icon: InboundIcon,
        primary: true,
      }}
    >
         <div style={{ paddingBottom:"30px" }}>
    <Layout >
          <Layout.Section>
                  <div style={{ width: "100%", marginRight: "20px", marginBottom: "20px" }}>
                        {showInfo && (
                             <Banner onDismiss={() => setShowInfo(false)}>
                              <Text as="p" fontWeight="medium">
                                Here you can view the products from your eBay store and easily import them into your Shopify store.
                              </Text>
                            </Banner>
                        )}
                    {
                      eb_pending_request == '1' && (
                            <Banner onDismiss={() => {setEbPendingRequest(0)}}>
                            <Text as="p" fontWeight="medium">
                              We are currently fetching the products from eBay, and the process will be completed soon. Import 5 products for FREE and start selling faster.
                            </Text>
                          </Banner>
                      )
                    }
                    {
                    eb_pending_request == '2' && productCount.ebproduct > 0 && (
                     <Banner onDismiss={() => setEbPendingRequest(0)}>
                      <Text as="p" fontWeight="medium">
                        The product fetch process has been completed.
                      </Text>
                    </Banner>
                    )
                  }
                  {productCount.ebproduct == 0 && eb_pending_request == '2' &&(
                    <Banner >
                      <Text as="p" fontWeight="medium">
                        The product fetch process is complete, but no products were found in your <strong>eBay store.</strong> Please add products to your store and try again..
                      </Text>
                    </Banner>
                  )}
                        {data.user.skuconsumed === 5 && data.user.plan === 0 && (
                          <>
                      <Banner tone="critical">
                          Please upgrade your plan to continue importing items.
                          <Button
                            onClick={() =>
                              (window.location.href = `${process.env.REACT_APP_BASE_URL}/Plan&Pricing`)
                            }
                          >
                            Upgrade Plan
                          </Button>
                        </Banner>
    
                          </>
                        )}
                    
                  </div>
                  
            {isMobile && (
                 <>
                    <SearchBar fetchproduct={fetchproduct} whichPage={whichPage}  />
                      {content}
                 </>
                )}
                {!isMobile && (
                  <>

           <SearchBar fetchproduct={fetchproduct} whichPage={whichPage}  />
           
           {content}

                <Modal open={active} onClose={handleClose} title="Product Variation List" primaryAction={{ content: "Close", onAction: handleClose }}>
              <Modal.Section>
                {selectedVariants.length > 0 ? (
                  <table className="Polaris-Table variant-table">
                    <thead className="thead-variant">
                      <tr>
                        <th>Title</th>
                        <th>Sku</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Option1</th>
                        <th>Option2</th>
                        <th>Option3</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedVariants.map((variant, index) => (
                        <tr key={index}>
                          <td>{variant.title}</td>
                          <td>{variant.ebayitemid}</td>
                          <td>{variant.quantity}</td>
                          <td>{variant.price}</td>
                          <td>{variant.option1}</td>
                          <td>{variant.option2}</td>
                          <td>{variant.option3}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <Text>No Variants Available</Text>
                )}
              </Modal.Section>
                      </Modal>
                   
                  
           </>

                    )}
     
    <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f6f6f7",
                padding: "10px 16px",
                borderTop: "1px solid #dfe3e8",
                borderBottom: "1px solid #dfe3e8",
              }}
            >
              {/* Pagination controls */}
            <Pagination
                  onPrevious={() => {
                    fetchproduct(query, current_page - 1, perPageValue);
                  }}
                  onNext={() => {
                    fetchproduct(query, current_page + 1, perPageValue);
                  }}
                    hasPrevious={current_page !== 1}
                hasNext={current_page !== last_page}
                  type="table"
                  label={`${firstProductNo}-${LastProductNo} of ${totalpage} products`}

                />

              {/* Dropdown for per page selection */}
              <select
                name="perPageSelect"
                style={{
                  height: "32px",
                  padding: "4px 8px",
                  fontSize: "14px",
                  border: "1px solid #dfe3e8",
                  borderRadius: "4px",
                  backgroundColor: "#f6f6f7",
                  color: "#000",
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='black' height='12' viewBox='0 0 24 24' width='12' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 8px center",
                  backgroundSize: "12px",
                  paddingRight: "24px",
                  cursor: "pointer",
                }}
                value={perPageValue}
                onChange={handlePerPage}
              >
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
              <Modal
                open={upgradeModalActive}
                onClose={toggleUpgradeModal}
                title="Upgrade Required"
                primaryAction={{
                  content: 'Upgrade Plan',
                  onAction: () => {
                    window.open(`${process.env.REACT_APP_BASE_URL}/Plan&Pricing`)
                  },
                }}
                secondaryActions={[
                  {
                    content: 'Cancel',
                    onAction: toggleUpgradeModal,
                  },
                ]}
              >
                <Modal.Section>
                  <TextContainer>
                    <p>
                      You have reached your import limit. Please upgrade your plan to import more products.
                    </p>
                  </TextContainer>
                </Modal.Section>
              </Modal>
        </Layout.Section>
      </Layout>
    </div>
  </Page>

);
}

export default Products;